import SvgIcon from '@mui/material/SvgIcon';

export const MiroIcon = () => (
  <SvgIcon
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0468 0H39.4191C45.4047 0 50.2643 4.8205 50.2643 10.7579V38.902C50.2643 44.8394 45.4047 49.6599 39.4191 49.6599H11.0468C5.06124 49.6599 0.20166 44.8394 0.20166 38.902V10.7579C0.20166 4.8205 5.06124 0 11.0468 0Z"
      fill="#FFD02F"
    />
    <path
      d="M34.9892 6.20203H29.4925L34.0706 14.1823L23.9958 6.20203H18.4992L23.5366 15.9606L13.0025 6.20203H7.50586L13.0025 18.6207L7.50586 43.458H13.0025L23.5366 16.8424L18.4992 43.458H23.9958L34.0706 15.0788L29.4925 43.458H34.9892L45.0639 12.404L34.9892 6.20203Z"
      fill="#050038"
    />
  </SvgIcon>
);
